export default __webpack_public_path__ + "static/media/electricity.5bee7eb8.png";